export enum DatabaseUserStatus {
  CREATING,
  CREATED,
  ERROR,
}

export enum DatabaseStatus {
  CREATING,
  CREATED,
  ERROR,
}

export interface DatabaseLogInterface {
  id: number;
  log: string;
}

export interface DatabaseUserLogInterface {
  id: number;
  log: string;
}

export interface DatabaseInterface {
  id: number,
  name: string,
  websiteId: number,
  server: string,
  status: DatabaseStatus,
  size?: number,
  users: DatabaseUserInterface[]
  logs: DatabaseLogInterface[],
}

export interface UnixUserDBUserInterface {
  id: number;
  unixUserId: number;
}

export interface DatabaseUserInterface {
  id: number,
  username: string,
  status: DatabaseUserStatus,
  databases: DatabaseInterface[],
  logs: DatabaseUserLogInterface[],
  unixUser?: UnixUserDBUserInterface,
}

export interface DatabaseCreateInterface {
  name: string,
  server: string,
  websiteId: number,
  password: string,
  passwordConf: string,
}

export interface DatabaseUserCreateInterface {
  username: string,
  password: string,
  passwordConf: string,
  databaseId: number,
}

export interface DatabaseUserEditInterface {
  password: string,
  passwordConf: string,
  databaseId: number,
}

export interface MigrationTaskInterface {
  id: number;
  sourceId: number;
  targetId: number;
  type: string;
  status: string;
  createdAt: string;
}

export interface MigrationBatchInterface {
  id: number;
  sourceWebsiteId: number;
  targetWebsiteId: number;
  sourceServer: string;
  targetServer: string;
  tasks: MigrationTaskInterface[];
  status: string;
  createdAt: string;
}

export interface DatabaseRepositoryInterface {
  createDatabase(data: DatabaseCreateInterface): Promise<DatabaseInterface>;

  deleteDatabase(databaseId: number): Promise<void>;

  getDatabaseById(databaseId: number): Promise<DatabaseInterface>;

  getDatabases(page?: number, search?: string, websiteIds?: number[]): Promise<[DatabaseInterface[], number]>;

  getByWebsiteId(websiteId: number): Promise<DatabaseInterface[]>;

  getUsers(page: number, search?: string): Promise<[DatabaseUserInterface[], number]>;

  getAllDatabases(): Promise<DatabaseInterface[]>;

  createUser(data: DatabaseUserCreateInterface): Promise<DatabaseUserInterface>;

  deleteUser(userId: number): Promise<void>;

  getUserById(userId: number): Promise<DatabaseUserInterface>;

  editUser(userId: number, data: DatabaseUserEditInterface): Promise<void>;

  deleteDatabaseLog(id: number): Promise<void>;

  deleteUserLog(id: number): Promise<void>;

  syncDatabaseSize(id: number): Promise<void>;

  syncGroupDatabases(groupId: number): Promise<void>;

  getUserPlainPassword(id: number): Promise<string>;

  getAllMigrationBatches(): Promise<MigrationBatchInterface[]>;

  getMigrationBatchById(id: number): Promise<MigrationBatchInterface>;

  deleteMigrationBatch(id: number): Promise<void>;
}
